import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './Corner.css';
var cx = classnames.bind(styles);
export default function Corner(_ref) {
  var className = _ref.className,
      children = _ref.children,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["className", "children", "color"]);

  return React.createElement("div", _extends({
    className: cx('corner', color, className)
  }, rest), React.createElement("span", null, children));
}
Corner.propTypes = {
  /** Children node that will appear inside the corner component.
   * Styling may need to be supplied to this node. */
  children: PropTypes.node,

  /** Custom class name to be applied to the component */
  className: PropTypes.string,

  /** String that represents the color of the corner component */
  color: PropTypes.oneOf(['yellow', 'transparent', 'teal', 'red', 'evergreen', 'white', 'gold', 'grey', 'green', 'blueLight']) // TODO: need to implement yellow and transparent into GBColorPropType

};
Corner.defaultProps = {
  className: undefined,
  children: undefined,
  color: 'transparent'
};